import { RequestOptions } from './request-options';

export class UserRequest extends RequestOptions {
    Name: string = undefined;
    Region: string = undefined;
    Sex: number = undefined;
    Id_Tarif: string = undefined;
    FavPaymentType: number = undefined;
    ExternalSystem: string = undefined;
    HPassword: string = undefined;
    Hid_ExternalUser: string = undefined;
    ApiVersion: string = undefined;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/user-model.ts